import { render } from "./Messenger.vue?vue&type=template&id=1d104b3a&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"

import "./Messenger.vue?vue&type=style&index=0&id=1d104b3a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d104b3a"]])

export default __exports__